import { ILanguage } from "../types";

export const pl: ILanguage = {
  translation: {
    root: {
      customize: "Dostosuj",
      businessAccount: "Konto biznesowe",
      verificationStatus: "Status weryfikacji",
      note: "Notatka",
      companyInformation: "Informacje o firmie",
      businessName: "Nazwa firmy*",
      enterBusinessName: "Wprowadź nazwę firmy",
      registrationNumber: "Firma Reg. ",
      registrationNumberPlaceholder: "Wprowadź numer rejestracyjny",
      taxVat: "Nr rejestracji podatku/podatku VAT",
      vatPlaceholder: "Wprowadź numer rejestracyjny podatku/VAT",
      registeredAddress: "Zarejestrowany adres*",
      tradingAddress: "Adres handlowy*",
      sameAsRegisteredAddress: "Tak samo jak zarejestrowany adres",
      billingInformation: "Informacje o rozliczeniu",
      billingPhoneNo: "Nr telefonu rozliczeniowego*",
      phonePlaceholder: "Wprowadź numer telefonu ",
      billingEmail: "E -mail z rozliczeniami*",
      emailPlaceholder: "Wpisz e -mail z rozliczeniami",
      driverDetails: "Szczegóły kierowcy",
      customerVerificationStatus: "Status weryfikacji klienta:",
      enterNationalInsuranceNumber: "Wprowadź numer ubezpieczenia narodowego",
      enterYourProfession: "Wprowadź swój zawód",
      enterDriving: "Wprowadź jazdę",
      middleName: "Drugie imię",
      middleNameLabel: "Drugie imię",
      enterMiddleName: "Wpisz drugie imię",
      profileImage: "Obraz profilowy",
      number: "Numer",
      mode: "Tryb",
      comments: "Komentarze",
      image: "Obraz",
      uploadBack: "Prześlij z powrotem",
      uploadFront: "Prześlij przód",
      issuedBy: "Wydane przez",
      document: "Dokument",
      selectDocument: "Wybierz dokument",
      addFile: "Dodaj plik",
      noDataFound: "Nie znaleziono danych",
      noDocumentsFound: "Nie znaleziono dokumentów",
      documentUpdatedAt: "Dokument zaktualizowany na",
      selectExpiryDate: "Wybierz datę ważności",
      selectExpiryDateUpload: "Przed przesłaniem wybierz datę ważności.",
      editExpiryDate: "Edytuj datę ważności",
      status: "Status",
      images: "Obrazy",
      profession: "Zawód",
      nationality: "Narodowość",
      driving: "Napędowy",
      listOfDocumentsUploaded: "Lista przesłanych dokumentów",
      listOfRequiredDocumentsUploaded:
        "Lista przesłanych wymaganych dokumentów",
      documentType: "Typ dokumentu",
      documentName: "Nazwa dokumentu",
      expiryDate: "Data ważności",
      confirmDelete: "Potwierdź Usuń",
      actions: "Działania",
      completed: "Zakończony",
      pending: "Aż do",
      documentDeleteConfirmMsg: "Czy na pewno chcesz usunąć ten dokument?",
      address: "Adres",
      useRegisteredAddress: "Użyj zarejestrowanego adresu",
      billingEmailAddress: "Adres e -mail rozliczeniowy*",
      billingEmailLabel: "Adres e -mail rozliczeniowy",
      accountNumber: "Numer konta",
      firstName: "Imię*",
      firstNameLabel: "Imię",
      lastName: "Nazwisko*",
      lastNameLabel: "Nazwisko",
      contactEmail: "Skontaktuj się z adresem e -mail*",
      emailLabel: "Adres e -mail",
      contactPhone: "Kontakt telefon nr*",
      registeredAddressCaps: "Zarejestrowany adres",
      tradingAddressCaps: "Adres handlowy",
      billingInformationCaps: "Informacje o rozliczeniu",
      customerContactCaps: "Kontakt z klientem",
      contactEmailInvalid: "Wprowadź prawidłowy e -mail kontaktowy.",
      typeAddress: "Typ adres",
      taxFees: "Podatki i opłaty",
      vatTax: "VAT/podatek",
      registrationNum: "Numer rejestracyjny",
      drivingLicenceNumber: "Numer prawa jazdy",
      invalidPhoneNumber: "Nieprawidłowy numer telefonu",
      onStartEmail: "Wysłaliśmy Ci e -mailem, jak zacząć.",
      emailNotSeen:
        "Jeśli nie zobaczysz e -maila za kilka minut, sprawdź „śmieciową pocztę” lub „folder spamowy”.",
      registerNow: "Zarejestruj się teraz",
      email: "E-mail",
      thankYou: "Dziękuję",
      pickUpLocation: "Miejsce odbioru ",
      returnLocation: "Miejsce zwrotu *",
      pickUpDate: "Data odbioru *",
      pickUpTime: "Godzina odbioru *",
      invalidPickupLeadTime: "Wybrana data/godzina odbioru jest poza dozwolonym oknem rezerwacji",
      dropOffDate: "Data zwrotu *",
      searchVehicles: "Szukaj pojazdów",
      chooseLocation: "Wprowadź lokalizację lub kod pocztowy",
      vehicleGallery: "Galeria pojazdów",
      privacyPolicy: "Polityka prywatności",
      termsAndConditions: "Warunki i zasady",
      dropOffTime: "Godzina zwrotu *",
      noVehiclesFound: "Nie znaleziono pojazdów spełniających wybrane kryteria",
      noRecordFound:
        "Przepraszamy, nie znaleziono żadnych pasujących rekordów!",
      vehicles: "Pojazdy",
      endDate: "Data zakończenia",
      startDate: "Data rozpoczęcia",
      past: "Przeszłość",
      search: "Szukaj",
      upcoming: "Nadchodzące",
      current: "Obecne",
      all: "Wszystko",
      more: "Więcej",
      toBeAssigned: "Do przypisania",
      ref: "Nr referencyjny",
      reservation: "Rezerwacja",
      booking: "Rezerwacja",
      pricingSummary: "Podsumowanie cen",
      bookingSummary: "Podsumowanie rezerwacji",
      subscriptionVehicle: "Pojazd subskrypcyjny",
      insurance: "Ubezpieczenie",
      addons: "Dodatki",
      protectionPlan: "Plan ochrony",
      initialRental: "Początkowy wynajem",
      enrollmentFee: "Opłata rejestracyjna",
      quantity: "Ilość",
      subscriptionPrice: "Cena subskrypcji",
      weekly: "Tygodniowo",
      monthly: "Miesięcznie",
      on: "na",
      numberOfDoors: "Liczba drzwi",
      numberOfSeats: "Liczba miejsc",
      transmission: "Skrzynia biegów",
      fuelType: "Rodzaj paliwa",
      week: "Tydzień",
      day: "Dzień",
      hour: "Godzina",
      month: "Miesiąc",
      gropu1Icon: "Ikona grupy 1",
      vatInclusive: "Z VAT",
      vat: "VAT",
      rental: "Wynajem",
      speedometer: "Prędkościomierz",
      available: "Dostępne",
      priceLowToHigh: "Cena rosnąco",
      priceHighToLow: "Cena malejąco",
      weHaveSmartCars: "Posiadamy inteligentne samochody",
      keylessSupport:
        "Nasze inteligentne samochody obsługują bezkluczykowy dostęp",
      keylessVehicles: "Pojazdy bezkluczykowe",
      duration: "Czas trwania",
      swapsAllowed: "Zamiany dozwolone",
      enrollmentAmount: "Kwota rejestracyjna",
      subscriptionAmount: "Kwota subskrypcji",
      mileageLimit: "Limit przebiegu",
      unlimited: "Nieograniczony",
      weeks: "Tygodnie",
      months: "Miesiące",
      pricePerExtraMile: "Cena za dodatkową milę",
      insurancePolicy: "Polisa ubezpieczeniowa",
      removeSubscription: "Usuń subskrypcję",
      noGroupFound: "Nie znaleziono grup pasujących do tych kryteriów!",
      vehicleTypeIcon: "Ikona typu pojazdu",
      min: "Min",
      selected: "Wybrane",
      vehiclesSelected: "Wybrane pojazdy",
      selectVehicles: "Wybierz pojazdy",
      personalDetails: "Dane osobowe",
      selectAddons: "Wybierz dodatki",
      continue: "Kontynuuj",
      locationSurcharge: "Dopłata lokalizacyjna",
      onTotalRentalAmount: "od całkowitej kwoty wynajmu",
      oneWayFee: "Opłata za przejazd w jedną stronę",
      oneWayRentalCharge: "Opłata za wynajem w jedną stronę",
      total: "Łącznie",
      firstMonthTotal: "Razem za pierwszy miesiąc",
      firstWeekTotal: "Razem za pierwszy tydzień",
      depositPayable: "Kaucja płatna przy odbiorze",
      deposit: "Kaucja",
      insuranceCaps: "UBEZPIECZENIE",
      customAddon: "Dodatek niestandardowy",
      chooseAPolicy: "Wybierz polisę",
      rate: "Stawka",
      typeOfValet: "Rodzaj parkowania",
      nonNegotiable: "Nie podlega negocjacji",
      selectValet: "Wybierz parkingowego",
      collectionAddress: "Adres odbioru",
      remove: "Usuń",
      deliveryAddress: "Adres dostawy",
      additionalInformation: "Dodatkowe informacje",
      confirmBooking: "Potwierdź rezerwację",
      proceed: "Przejdź dalej",
      getQuote: "Uzyskaj wycenę",
      for: "dla",
      agreeWithTermsAndConditions: "Zgadzam się z regulaminem",
      selectCostCenter: "Wybierz centrum kosztów",
      action: "Akcja",
      name: "Imię",
      enterDrivingLicenceNumber: "Wprowadź numer prawa jazdy",
      enterLastName: "Wprowadź nazwisko",
      enterFirstName: "Wprowadź imię",
      enterYourMail: "Wprowadź swój e-mail",
      emailAsterisk: "E-mail*",
      quoteGeneratedCaps: "WYCENA WYGENEROWANA",
      updated: "Zaktualizowano",
      rentalCharges: "Opłaty za wynajem",
      totalPayableAmount: "Całkowita kwota do zapłaty",
      payMinimumAmount: "Zapłać minimalną kwotę",
      dueAmountPaidWhilePickup: "Kwota należna przy odbiorze",
      payOnCollection: "Zapłać przy odbiorze",
      CardAuthorization:
        "Karta została autoryzowana teraz, kwota zostanie pobrana:",
      starts: "Zaczyna się",
      confirm: "Potwierdź",
      payAtTimeOfPickup: "Nie płać teraz, zapłać przy odbiorze",
      payFullAmountNow: "Zapłać pełną kwotę teraz",
      payFullAmountRightAway: "Zapłać od razu całą kwotę",
      FutureChargesRelatedToOngoingBooking:
        "Przyszłe opłaty związane z trwającą rezerwacją zostaną pobrane z tej metody płatności",
      saveThisCardForFutureInvoices:
        "Zapisz tę kartę do przyszłych faktur {{bookingSyntax}}",
      payLater: "Zapłać później",
      creditLimitAssigned:
        "Przydzielony limit kredytowy dla tej firmy zostanie użyty do płatności",
      CreditsAgainstBooking: "Kredyty zostaną zastosowane do rezerwacji",
      useCreditNoteBalance: "Użyj salda noty kredytowej",
      telNo: "Nr tel.",
      vatNo: "Numer VAT",
      customer: "Klient",
      emailAddress: "Adres e-mail",
      phoneNumber: "Numer telefonu",
      dateCreated: "Data utworzenia",
      poNumber: "Numer zamówienia",
      dateTime: "Data i godzina",
      dropOffLocation: "Miejsce zwrotu",
      contractHire: "Wynajem kontraktowy",
      subscription: "Subskrypcja",
      charges: "Opłaty",
      enrollmentFees: "Opłaty rejestracyjne",
      na: "Nie dotyczy",
      grandTotal: "Suma końcowa",
      rentalPrice: "Cena wynajmu",
      daysProRated: "Dni proporcjonalne",
      locationSurcharges: "Dopłaty lokalizacyjne",
      ofTotalRentalAmount: "całkowitej kwoty wynajmu",
      nextBilling: "Następne rozliczenie",
      subTotal: "Suma częściowa",
      discount: "Zniżka",
      discountedPrice: "Cena z rabatem",
      description: "Opis",
      descriptionLabel: "Opis",
      thisIsA: "To jest",
      exemptedBooking: "rezerwacja zwolniona",
      thisIstestCourtsey: "To jest test / rezerwacja uprzejmościowa",
      isCalculatedAgainst: "jest obliczane względem",
      priceAndSelectedAddons:
        "ceny i wybranych dodatków z wyłączeniem ubezpieczenia i depozytu",
      recurringWeeklyMonthlyInvoice:
        "Cykliczna faktura tygodniowa/miesięczna będzie automatycznie generowana dla następnego okresu.",
      additionalNote: "Dodatkowa uwaga",
      payableAtVehicleCollection: "Kwota płatna przy odbiorze pojazdu",
      purchaseOrderUpdated: "Numer zamówienia został pomyślnie zaktualizowany",
      proceedToPay: "Przejdź do płatności",
      searchResults: "Wyniki wyszukiwania",
      subscriptions: "Subskrypcje",
      contractHireVehicleWeeklyMonthly: "Wynajem pojazdu na tydzień/miesiąc",
      subscribeVehicleWeeklyMonthly: "Subskrybuj pojazd na tydzień/miesiąc",
      contractNow: "Podpisz umowę teraz",
      subscribeNow: "Subskrybuj teraz",
      backToBookingCategorySelection: "Wróć do wyboru kategorii rezerwacji.",
      accountVerification: "Weryfikacja konta",
      profileNotVerifiedMessage:
        "Twój profil nie został zweryfikowany. Skontaktuj się z operatorem, aby zakończyć proces weryfikacji konta i kontynuować.",
      update: "Aktualizacja",
      reference: "Referencja",
      companyRegistrationNumber: "Numer rejestracyjny firmy",
      availableFrom: "Dostępne od",
      paellaDish: "Danie paella",
      vehicleCatalogues: "Katalogi Pojazdów",
      vehicleDetails: "Szczegóły Pojazdu",
      verification: "Weryfikacja",
      protectionPlans: "Plany ochrony",
      authorisedSignatory: "Upoważniony podpisujący",
      item: "Przedmiot",
      price: "Cena",
      unitPrice: "Cena jednostkowa",
      vehicleSpecification: "Specyfikacja pojazdu",
      model: "Model",
      color: "Kolor",
      bodyType: "Typ nadwozia",
      tankCapacity: "Pojemność zbiornika",
      interiorColor: "Kolor wnętrza",
      seats: "Siedzenia",
      doors: "Drzwi",
      whatsIncluded: "Co jest w zestawie",
      timeVehicleSwap: "czas na wymianę pojazdu",
      contractualDetails: "Szczegóły umowy",
      longerSubscribeSaveMore:
        "Im dłużej subskrybujesz, tym więcej oszczędzasz",
      tailorSubscriptionToNeeds: "Dostosuj subskrypcję do swoich potrzeb",
      easyManagementOnline: "Łatwa i wygodna obsługa online",
      SwapCarAndCancel: "Zmień samochód lub anuluj w każdej chwili",
      customizeYourContract: "Dostosuj swoją umowę",
      selectPlan: "Wybierz plan",
      selectTenure: "Wybierz okres",
      tentativeStartDate: "Przybliżona data rozpoczęcia",
      selectDate: "Wybierz datę",
      selectTime: "Wybierz godzinę",
      contractSummary: "Podsumowanie umowy",
      subscriptionChargesLabel: "Opłaty subskrypcyjne",
      initialRentalPayment: "Wstępna opłata za wynajem",
      continueToPersonalDetails: "Przejdź do danych osobowych",
      noAvailableAddonsFound:
        "Nie znaleziono dostępnych dodatków spełniających kryteria wyszukiwania",
      nationalInsuranceNumber: "Numer ubezpieczenia narodowego",
      updateQuote: "Zaktualizuj ofertę",
      driverNotAvailable:
        "Kierowca jest niedostępny, skontaktuj się z operatorem wynajmu",
      selectDeliverySlot: "Wybierz przedział czasowy dostawy",
      wantDelivered: "Czy chcesz, aby pojazd został dostarczony?",
      verifyYourLicenceCaps: "ZWERYFIKUJ SWOJE PRAWO JAZDY",
      validateAllFieldsForLicenceCheck:
        "Proszę uzupełnić lub zweryfikować poniższe dane w celu sprawdzenia prawa jazdy. Wszystkie pola są obowiązkowe.",
      postCode: "Kod pocztowy",
      thisAgreementAllows: "Umowa pozwala",
      leftoverAgreement:
        "naszemu partnerowi ubezpieczeniowemu na przeprowadzenie kontroli twojego prawa jazdy i przekazanie danych ubezpieczycielom i innym stronom (Coastr) w celu obsługi wynajmu i ubezpieczenia. Czy wyrażasz zgodę?",
      verifyLicence: "Zweryfikuj prawo jazdy",
      licenceCheckingInProgress: "Trwa sprawdzanie prawa jazdy",
      checkingInProgress:
        "Może to potrwać do 2 minut, prosimy o cierpliwość i nie zamykaj przeglądarki",
      licenceCheckingFailed: "Nie udało się sprawdzić prawa jazdy",
      checkForCorrectDetails: "Sprawdź, czy dane zostały wpisane poprawnie.",
      tryAgainLater: "Jeśli problem nadal występuje, spróbuj ponownie później.",
      licenceCheckedSuccessfully: "Prawo jazdy zostało pomyślnie zweryfikowane",
      licenceSummaryAdded:
        "Podsumowanie prawa jazdy zostało dodane do profilu klienta",
      creditScore: "Wynik kredytowy",
      lastChecked: "Ostatnio sprawdzono",
      recheckCreditScore: "SPRAWDŹ PONOWNIE WYNIK KREDYTOWY",
      checkCreditScore: "SPRAWDŹ WYNIK KREDYTOWY",
      proceedToPayment: "Przejdź do płatności",
      paymentOverview: "Przegląd płatności",
      schedule: "Harmonogram",
      contractDetails: "Szczegóły umowy",
      plan: "Plan",
      swaps: "Zamiany",
      payableDeposit: "Depozyt do zapłaty",
      customerVerification: "Weryfikacja klienta",
      provideAdditionalDetails:
        "Proszę podać poniższe dodatkowe informacje w sekcji konta, aby utworzyć rezerwację",
      profilePhoto: "Zdjęcie profilowe",
      submitYourRequest:
        "Po zakończeniu proszę przesłać swoją prośbę o zatwierdzenie, klikając przycisk 'Wyślij' poniżej",
      submit: "Wyślij",
      uploadLicenceImages: "Prześlij zdjęcia prawa jazdy",
      add: "Dodaj",
      uploadFrontBackLicence:
        "Prześlij przedni i tylny obraz prawa jazdy. Obsługiwane formaty: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Prześlij obraz prawa jazdy",
      authority: "Organ",
      drivingLicenceExpiryDate: "Data ważności prawa jazdy",
      licenceNumber: "Numer prawa jazdy",
      preview: "Podgląd",
      addOn: "Dodatek",
      contact: "Kontakt",
      selectSlot: "Wybierz gniazdo",
      deliveryType: "Rodzaj dostawy",
      experience: "Doświadczenie",
      type: "Typ",
      bookATestDrive: "Zarezerwuj jazdę próbną",
      selectASlot: "Wybierz przedział czasowy",
      selectDateTimeSlot: "Wybierz datę i godzinę",
      vehicleNotAvailable: "Pojazd niedostępny w wybranym terminie",
      selectDifferentDate: "Proszę wybrać inny termin",
      selectCar: "Wybierz samochód",
      availableNow: "Dostępny teraz",
      new: "Nowy",
      phone: "Telefon",
      customerDetails: "Szczegóły klienta",
      dealershipAddress: "Adres dealera",
      dealership: "Dealer",
      bookingTime: "Czas rezerwacji",
      bookingType: "Typ rezerwacji",
      details: "Szczegóły",
      your: "Twój",
      confirmation: "Potwierdzenie",
      selectDealership: "Wybierz dealera",
      testDriveRequested: "Jazda próbna została zażądana",
      testDrive: "Jazda próbna",
      mobileNumber: "Numer telefonu komórkowego",
      drivingLicenseNumber: "Numer prawa jazdy",
      enterLicenseNumber: "Wpisz numer prawa jazdy",
      requestTestDrive: "Złóż wniosek o jazdę próbną",
      slot: "Przedział",
      vehicle: "Pojazd",
      selectSubsctiption: "WYBIERZ SUBSKRYPCJĘ",
      pricesShownOnSelectedDuration:
        "Wyświetlane ceny oparte są na wybranym czasie trwania",
      priceComparison: "Porównanie cen",
      oneTime: "Jednorazowo",
      subscriptionStartsAt: "Subskrypcja zaczyna się od",
      paymentProcessing: "Przetwarzanie płatności",
      pleaseWait: "Proszę czekać",
      paymentComplete: "Płatność zakończona",
      paymentInProgress: "Płatność w toku",
      atleastUploadOne: "Prześlij przynajmniej jeden",
      upload: "Prześlij",
      uploadServiceNotAvailable: "Usługa przesyłania niedostępna. Spróbuj ponownie.",
      uploading: "Przesyłanie...",
      atDealership: "W salonie",
      atHome: "W domu",

      enterYourEmailPassword: "Wprowadź swój e-mail i hasło, aby się zalogować",
      enterMailHere: "Wprowadź swój e-mail tutaj",
      required: "Wymagane",
      password: "Hasło",
      reset: "Resetuj",
      otpForPasswordReset: "Otrzymasz kod OTP na e-mail do zresetowania hasła",
      sendOtp: "Wyślij OTP",
      loginInstead: "Zaloguj się zamiast tego",
      verifyOtp: "Zweryfikuj OTP",
      otp: "OTP",
      otpSentToEmail: "OTP zostało wysłane na Twój e-mail",
      enterOtp: "Wprowadź OTP",
      enterOtpHere: "Wprowadź tutaj OTP",
      verify: "Zweryfikuj",
      setNewPassword: "Ustaw nowe hasło",
      eightCharLong: "Musi mieć 8 znaków",
      reenterPassword: "Wprowadź ponownie hasło tutaj",
      signInAs: "Zaloguj się jako",
      as: "Jako",
      selectAccountToProceed: "Wybierz konto, aby kontynuować",
      personalAccount: "Konto osobiste",
      asBusinessCustomer: "Jako klient biznesowy",
      asDriver: "Jako kierowca",
      enterPassword: "Wprowadź tutaj hasło",
      registerAs: "Zarejestruj się jako",
      individual: "Osoba prywatna",
      business: "Firma",
      operatorMandatedCustomerCheck:
        "Operator wymaga weryfikacji klienta przed potwierdzeniem rezerwacji. Proszę poczekać na zatwierdzenie.",
      createAccount: "Utwórz konto",
      emailedHowToGetStarted:
        "Wysłaliśmy do Ciebie maila z instrukcjami, jak zacząć.",
      ifDontSeeEmail:
        "Jeśli nie widzisz maila w ciągu kilku minut, sprawdź folder spam lub niechciane.",
      previousVehicleDetails: "Dane poprzedniego pojazdu",
      registration: "Rejestracja",
      makeModel: "Marka/Model",
      vin: "Numer VIN",
      driverAssigned: "Przypisany kierowca",
      currentVehicleDetails: "Dane obecnego pojazdu",
      priceGroup: "Grupa cenowa",
      unlimitedMileage: "Nieograniczony przebieg",
      paymentStatus: "Status płatności",
      invoiceNumber: "Numer faktury",
      deliveryDetails: "Szczegóły dostawy",
      collectionDetails: "Szczegóły odbioru",
      coiDetails: "Szczegóły COI",
      policyName: "Nazwa polisy",
      planName: "Nazwa planu",
      policyNumber: "Numer polisy",
      provider: "Dostawca",
      vehicleSwapDetails: "Szczegóły wymiany pojazdu",
      swapMyCar: "Zamień mój samochód",
      NoOfSwapsAllowed: "Dozwolona liczba wymian",
      NoOfSwapsAvailed: "Wykorzystane wymiany",
      NoOfSwapsRemaining: "Pozostałe wymiany",
      swapRequestHistory: "HISTORIA ZAPYTAŃ O WYMIANĘ",
      requestedOn: "ZAPYTANIE W DNIU",
      swapDate: "DATA WYMIANY",
      oldVehicle: "Stary pojazd",
      newVehicle: "Nowy pojazd",
      addonsDetails: "Szczegóły dodatków",
      paymentDetails: "Szczegóły płatności",
      billingPeriod: "Okres rozliczeniowy",
      creationDate: "Data utworzenia",
      invoiceType: "Typ faktury",
      regular: "Standardowy",
      depositDetails: "Szczegóły depozytu",
      amount: "Kwota",
      totalPaidAmount: "Całkowita zapłacona kwota",
      cancellationCharges: "Opłaty za anulowanie",
      totalRefundAmount: "Łączna kwota zwrotu",
      anUnpaid: "niezapłacona",
      aPartiallyPaid: "częściowo opłacona",
      thisIs: "To jest",
      pleaseContactUs: "Prosimy o kontakt w razie pytań",
      reasonToCancelTheBooking: "Wybierz powód anulowania rezerwacji",
      enterTheReason: "Wprowadź powód",
      dismiss: "Odrzuć",
      selectVehicle: "Wybierz pojazd",
      bookingConfirmationInProgress: "Potwierdzenie rezerwacji w toku",
      pleaseProvideTheReason: "Proszę podać powód",
      quote: "Oferta",
      management: "Zarządzanie",
      pickupDateTimePassed: "Data/czas odbioru minął lub jest bez opłat",
      profileRejectedOrPending:
        "Twój profil został odrzucony lub jest w toku weryfikacji",
      testDriveAgreement: "Umowa jazdy próbnej",
      rentalAgreement: "Umowa najmu",
      contractHireAgreement: "Umowa najmu na kontrakt",
      subscriptionAgreement: "Umowa subskrypcji",
      zeroChargeBooking: "Rezerwacja bez opłat może potwierdzić tylko operator",
      pickupDateTimeInPast: "Data/czas odbioru leży w przeszłości",
      creditNoteSummary: "Podsumowanie noty kredytowej",
      customerName: "Imię i nazwisko klienta",
      customerEmail: "E-mail klienta",
      creditNoteRef: "Referencja noty kredytowej",
      invoiceRef: "Referencja faktury",
      totalAmount: "Całkowita kwota",
      amountAdjustedRefunded: "Kwota skorygowana/zwrot",
      amountAvailable: "Dostępna kwota",
      adjustments: "Korekty",
      particulars: "Szczegóły",
      adjustedToInvoice: "Skorygowane na fakturze",
      adjustedAt: "Skorygowano w dniu",
      creditNotes: "Noty kredytowe",
      availableBalance: "Dostępne saldo",
      searchCreditNoteId: "Wyszukaj ID noty kredytowej",
      active: "Aktywny",
      exhausted: "Wyczerpany",
      creditNoteId: "ID noty kredytowej",
      dateGenerated: "Data wygenerowania",
      amountRefunded: "Kwota zwrócona",
      amountRemaining: "Pozostała kwota",
      dashboard: "Panel",
      activeVehiclesCount: "Liczba aktywnych pojazdów",
      totalActiveBookings: "Łączna liczba aktywnych rezerwacji",
      totalVehicles: "Wszystkie pojazdy",
      vehicleChecks: "Kontrole pojazdu",
      inProgressBookings: "Rezerwacje w toku",
      vehicleChecksCompleted: "Kontrole pojazdu zakończone",
      vehicleChecksPending: "Kontrole pojazdu oczekujące",
      dailyBalance: "Saldo dzienne",
      totalOutstanding: "Wszystkie zaległości",
      UnpaidInvoices: "Liczba nieopłaconych faktur",
      regularInvoices: "Faktury standardowe",
      sundryInvoices: "Różne faktury",
      addNewDriver: "Dodaj nowego kierowcę",
      phoneNo: "Nr telefonu",
      drivingLicenceImage: "Zdjęcie prawa jazdy",
      licenceIssuedBy: "Prawo jazdy wydane przez",
      licenceExpiryDate: "Data wygaśnięcia prawa jazdy",
      drivingLicenceIssueDate: "Data wydania prawa jazdy",
      dateOfBirth: "Data urodzenia",
      taskDetailsNotFound: "Szczegóły zadania nie znaleziona.",
      bookingRef: "Ref. rezerwacji",
      pcoIssueDate: "Data wydania licencji PCO kierowcy",
      rateYourExperience: "Oceń swoje doświadczenie",
      driverInformation: "Informacje o kierowcy",
      saveDrivers: "Zapisz kierowców",
      expiry: "Wygasa",
      areYouSureDriver: "Czy na pewno chcesz usunąć tego kierowcę?",
      drivers: "Kierowcy",
      noDriverFound: "Niestety, nie znaleziono żadnego kierowcy!",
      invoices: "Faktury",
      searchInvoiceId: "Wyszukaj ID faktury",
      unpaid: "Nieopłacone",
      paid: "Opłacone",
      void: "Unieważnione",
      invoiceId: "ID faktury",
      invoiceDate: "Data faktury",
      balanceDue: "Należność",
      dueDate: "Data płatności",
      invoiceSummary: "Podsumowanie faktury",
      invoice: "Faktura",
      sundry: "Różne",
      addPayment: "Dodaj płatność",
      customerPhoneNumber: "Telefon klienta",
      invoiceReference: "Referencja faktury",
      period: "Okres",
      invoiceVoidedBy: "Faktura unieważniona przez",
      invoicePeriod: "Okres fakturowania",
      invoiceStatus: "Status faktury",
      invoiceAmount: "Kwota faktury",
      amountDue: "Do zapłaty",
      generatedAt: "Wygenerowano:",
      vehicleRentalCharges: "Opłaty za wynajem pojazdu",
      refundable: "Zwracalne",
      date: "Data",
      thisIsTestCourtsey: "To test/okazjonalnie",
      invoicesConsolidated: "Faktury skonsolidowane",
      payments: "Płatności",
      exempted: "Zwolnione",
      pleaseLoginFirst: "Zaloguj się najpierw",
      account: "Konto",
      tracking: "Śledzenie",
      uploadImages: "Prześlij zdjęcia",
      updateVehicleState: "Zaktualizuj stan pojazdu",
      vehicleImage: "Zdjęcie pojazdu",
      fuelStatus: "Stan paliwa",
      batteryStatus: "Stan baterii",
      odometerReading: "Stan licznika",
      nextServiceDetails: "Szczegóły następnego serwisu",
      serviceType: "Rodzaj serwisu",
      serviceStatus: "Status serwisu",
      appointmentDate: "Data wizyty",
      estdCompletionDate: "Szacowana data zakończenia",
      serviceProviderName: "Nazwa dostawcy",
      serviceProviderAddress: "Adres dostawcy",
      notesForDriver: "Uwagi dla kierowcy",
      exteriorDamages: "Uszkodzenia zewnętrzne",
      interiorDamages: "Uszkodzenia wewnętrzne",
      generalChecks: "Ogólne kontrole",
      accessoriesChecks: "Kontrole akcesoriów",
      chooseFuelLevel: "Wybierz poziom paliwa",
      lastReported: "Ostatnio zgłoszono",
      circumstance: "Okoliczności",
      title: "Tytuł",
      damageKind: "Rodzaj uszkodzenia",
      damageArea: "Obszar uszkodzenia",
      referenceNumber: "Numer referencyjny",
      damageDetail: "Szczegóły uszkodzenia",
      addImage: "Dodaj zdjęcie",
      addImages: "Dodaj zdjęcia",
      done: "Gotowe",
      searchExistingDriver: "Szukaj istniejącego kierowcy",
      success: "Sukces",
      assignDriver: "Przydziel kierowcę",
      plate: "Rejestracja",
      unassigned: "Nieprzydzielone",
      assigned: "Przydzielone",
      make: "Marka",
      vehicleAppearOnceAssigned: "Pojazdy pojawią się po przydzieleniu!",
      searchVehicle: "Szukaj pojazdu",
      trackingHistoryHrs: "Historia śledzenia (godziny)",
      telemetryDevice: "Urządzenie telemetryczne",
      lastLocation: "Ostatnia lokalizacja",
      latitude: "Szerokość geograficzna",
      longitude: "Długość geograficzna",
      forSelectedPeriod: "Dla wybranego okresu –",
      milesDriven: "Przejechane mile",
      engineHours: "Motogodziny",
      fuelUsageLitres: "Zużycie paliwa (l)",
      stoppagehours: "Godziny postoju",
      chargeStatus: "Status ładowania",
      fuelUsage: "Zużycie paliwa",
      batteryLevel: "Poziom baterii",
      speedLimit: "Ograniczenie prędkości",
      invalidEmailAddress: "Nieprawidłowy e-mail",
      unableLoadCompanyDetails: "Nie można załadować danych firmy",
      bookingConfirmationProgress: "Potwierdzenie rezerwacji w toku...",
      doNotHitBack:
        "Proszę nie naciskać wstecz, anulować ani zamykać przeglądarki. Proces może potrwać do 2 minut.",
      summary: "Podsumowanie",

      addNew: "Dodaj nowy",
      street: "Ulica",
      city: "Miasto",
      regionState: "Region/Województwo",
      country: "Kraj",
      zipPostalCode: "Kod pocztowy",
      cardAuthorizeNowButAmountLater:
        "Karta zostanie autoryzowana teraz, ale kwota zostanie pobrana przy rozpoczęciu rezerwacji",
      saveThisCardForFutureInvoicesBooking:
        "Zapisz tę kartę do płatności za przyszłe faktury tej rezerwacji.",
      confirmBookingPayLater: "Potwierdź rezerwację, zapłać później",
      confirmBookingAndPayAtPickup: "Potwierdź teraz i zapłać przy odbiorze",
      bookingReferenceNumber: "Numer referencyjny rezerwacji",
      pickupDetails: "Szczegóły odbioru",
      dropoffDetails: "Szczegóły zwrotu",
      to: "Do",
      bookingReference: "Referencja rezerwacji",
      invoiceStartDate: "Data rozpoczęcia faktury:",
      invoiceEndDate: "Data zakończenia faktury:",
      availableAtLocations: "Dostępne w lokalizacjach",
      benefits: "Korzyści",
      passportNumber: "Numer paszportu",
      enterPassportNumber: "Wprowadź numer paszportu",
      vehicleSwapRequest: "Żądanie zamiany pojazdu",
      checkVehicleAvailability: "Sprawdź dostępność pojazdu",
      pleaseSelectDateAndSearch:
        "Wybierz datę i kliknij szukaj, aby sprawdzić dostępność pojazdu",
      noVehicleFoundForSelectedDate: "Nie znaleziono pojazdu na wybrany termin",
      notes: "Notatki",
      writeYourNoteHere: "Napisz tutaj swoją notatkę",
      updateRequest: "Zaktualizuj żądanie",
      generateRequest: "Wygeneruj żądanie",
      cancelRequest: "Anuluj żądanie",
      operator: "Operator",
      you: "Ty",
      maximum: "Maksimum",
      imagesAreAllowed: "można przesłać obrazy.",
      dragAndDropFile: "Przeciągnij i upuść plik lub kliknij",
      areAllowed: "są dozwolone",
      cancelBooking: "Anuluj rezerwację",
      booked: "Zarezerwowany",
      organisation: "Organizacja",
      vatNumber: "Numer VAT",
      sort: "Sortuj",
      DELETE_DRIVER_DESCRIPTION: "Czy na pewno chcesz usunąć kierowcę?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Czy na pewno chcesz usunąć kierowcę?",
        "Delete Driver": "Usuń kierowcę",
      },
      currentInvoiceStatus: {
        PAID: "ZAPŁACONO",
        UNPAID: "NIEZAPŁACONO",
        VOID: "UNIEWAŻNIONY",
        "PARTIALLY PAID": "CZĘŚCIOWO ZAPŁACONO",
        DRAFT: "SZKIC",
      },
      currentBookingStatus: {
        CANCELLED: "ANULOWANO",
        COMPLETED: "ZAKOŃCZONO",
        "CONFIRMATION IN PROCESS": "TRWA POTWIERDZENIE",
        CONFIRMED: "POTWIERDZONO",
        "IN PROGRESS": "W TRAKCIE",
        QUOTE: "WYCENA",
        DRAFT: "SZKIC",
        "REQUIRES APPROVAL": "WYMAGA ZATWIERDZENIA",
        DECLINED: "ODRZUCONO",
      },
      minBookingDurationMessage:
        "Minimalny czas rezerwacji to {{hours}} godzin. Proszę dostosować datę i godzinę odbioru lub zwrotu.",
      maxBookingDurationMessage:
        "Maksymalny czas rezerwacji to {{days}} dni. Proszę dostosować datę i godzinę odbioru lub zwrotu.",
      usevaletTypes: {
        Delivery: "Dostawa",
        Collection: "Odbiór",
        "Delivery and Collection": "Dostawa i odbiór",
      },
      selectCollectionSlot: "Wybierz przedział czasowy odbioru",
      driverUnavailableNote:
        "Uwaga: kierowca jest niedostępny, proszę skontaktować się z operatorem wynajmu.",
      cancellationReasons: {
        "Requirement changed": "Zmieniły się wymagania",
        Price: "Cena",
        Other: "Inne",
      },
      imagePreview: "Podgląd obrazu",
      markDamage: "Zaznacz uszkodzenie",
      vehicleDamageImages: "Zdjęcia uszkodzeń pojazdu",
      incidentDate: "Data zdarzenia",
      incidentTime: "Godzina zdarzenia",
      clear: "Wyczyść",
      bookingStatus: "Status rezerwacji",
      daysInBooking: "Dni w rezerwacji",
      accumulatedDays: "nagromadzone dni",
      endingThisMonth: "Zakończenie w tym miesiącu",
      creditUtilisation: "Wykorzystanie kredytu",
      creditLimit: "Limit kredytowy",
      utilized: "Wykorzystany",
      totalDrivers: "Całkowite sterowniki",
      vehiclesAllocated: "Przydzielone pojazdy",
      mileageOverview: "Przegląd przebiegu",
      mileageLimitExited: "Limit przebiegu wyszedł",
      approachingMileageLimits: "Zbliżające się limity przebiegu",
      motReminders: "MOT Reminders",
      totalMotTests: "Całkowite testy MOT",
      healthCheckReminders: "Przypomnienia o badaniach zdrowotnych",
      totalHealthCheckTests: "Łączna liczba badań kontrolnych",
      failed: "Przegrany",
      serviceReminders: "Przypomnienia serwisowe",
      overdue: "Zaległy",
      totalServiceReminders: "Całkowite przypomnienia o usługach",
      createNewServiceRequest: "Utwórz nowe zgłoszenie serwisowe",
      serviceDetails: "Szczegóły serwisu",
      selectedVehicle: "Wybrany pojazd",
      serviceRequestSelectVehicle: "Wybierz pojazd",
      loadingVehicles: "Ładowanie pojazdów...",
      noActiveVehiclesFound: "Nie znaleziono aktywnych pojazdów",
      addDetails: "Dodaj szczegóły",
      addItems: "Dodaj elementy",
      issueType: "Typ problemu",
      issueTypePlaceholder: "np. Zepsuta zamek",
      descriptionPlaceholder: "np. Zamek przednich lewych drzwi",
      uploaded: "Przesłano",
      additionalComments: "Dodatkowe uwagi",
      additionalCommentsPlaceholder: "Dodaj dodatkowe informacje...",
      submitting: "Przesyłanie...",
      submitRequest: "Wyślij zgłoszenie",
      serviceRequestNote: "Twoje zgłoszenie zostanie sprawdzone przez nasz zespół serwisowy. Otrzymasz powiadomienie po zatwierdzeniu lub jeśli potrzebne będą dodatkowe informacje.",
      serviceRequestDetails: "Szczegóły zgłoszenia serwisowego",
      createdDate: "Data utworzenia",
      estimatedCost: "Szacunkowy koszt",
      requestProgress: "Postęp zgłoszenia",
      issuesReported: "Zgłoszone problemy",
      issue: "Problem",
      imageAlt: "Obraz",
      serviceProvider: "Dostawca usług",
      appointment: "Wizyta",
      at: "o",
      estimatedCompletion: "Szacunkowe zakończenie",
      workToBeDone: "Prace do wykonania",
      cost: "Koszt",
      totalCost: "Całkowity koszt",
      requestDeclined: "Zgłoszenie odrzucone",
      communication: "Komunikacja",
      serviceTeam: "Zespół serwisowy",
      noCommunicationYet: "Brak komunikacji",
      addMessage: "Dodaj wiadomość",
      askQuestionPlaceholder: "Zadaj pytanie lub podaj dodatkowe informacje...",
      sending: "Wysyłanie...",
      sendMessage: "Wyślij wiadomość",
      additionalInformationRequested: "Zażądano dodatkowych informacji",
      provideFollowingInformation: "Proszę podać następujące informacje, aby pomóc nam przetworzyć Twoje zgłoszenie:",
      yourAnswer: "Twoja odpowiedź:",
      typeAnswerHere: "Wpisz tutaj swoją odpowiedź...",
      submitAnswers: "PRZEŚLIJ ODPOWIEDZI",
      approved: "Zatwierdzone",
      serviceRequests: "Wnioski o Usługę",
      scheduledServicesTitle: "Zaplanowane usługi",
      scheduledServicesBellAria: "Wyświetl zaplanowane usługi pojazdu",
      noScheduledServices: "Brak zaplanowanych usług",
      approveScheduledServiceSuccess: "Usługa została pomyślnie zatwierdzona",
      requestChangesSuccess: "Prośba o zmianę wysłana do zatwierdzenia",
      requestChanges: "Poproś o zmiany",
      modifyServiceRequest: "Modyfikuj zgłoszenie serwisowe",
      modifyDetails: "Modyfikuj szczegóły",
      vehicleAndCategory: "Pojazd i kategoria",
      cannotModify: "Nie można modyfikować",
      appointmentDetails: "Szczegóły terminu",
      time: "Godzina",
      scheduledServiceReviewHint: "Proszę przejrzeć zaplanowaną usługę. Zatwierdź, jeśli szczegóły są poprawne, lub poproś o zmiany.",
      approveService: "Zatwierdź usługę",
      jobSheet: "Karta pracy",
      declined: "Odrzucono",
      lastUpdated: "Ostatnia aktualizacja",
      explainChangesPlaceholder: "Wyjaśnij, dlaczego potrzebujesz tych zmian...",
      submitChanges: "Prześlij zmiany",
      expenses: "Wydatki",
      filters: "Filtry",
      applyFilters: "Zastosuj Filtry",
      activeFilters: "Aktywne Filtry",
      newServiceRequest: "Nowy Wniosek o Usługę",
      rowsPerPage: "Wierszy na stronę:",
      of: "z",
      moreThan: "więcej niż",
      searchServiceRequestsPlaceholder: "Szukaj według numeru referencyjnego, pojazdu lub statusu...",
      selectOption: "Wybierz opcję",
      selectMultiple: "Wybierz jedną lub więcej opcji",
      uploadPhoto: "Prześlij zdjęcie",
      view: "Wyświetl",
      typeYourResponse: "Wpisz swoją odpowiedź",
      pleaseSelectServiceType: "Proszę wybrać typ usługi",
      pleaseSelectServiceCategory: "Proszę wybrać kategorię usługi",
      selectServiceType: "Wybierz typ usługi",
      serviceCategory: "Kategoria usługi",
      selectServiceCategory: "Wybierz kategorię usługi",
      unableToDetermineServiceBranch: "Nie można określić oddziału serwisowego. Proszę spróbować ponownie później.",
      accidentDamageInformation: "Informacje o wypadku / uszkodzeniu",
      documentUploads: "Przesyłanie dokumentów",
      adHoc: "Ad-Hoc",
      emergency: "Nagły wypadek",
      serviceQuestionnaire: "Kwestionariusz Usługi",
      serviceQuestionnaireDescription: "Proszę podać kilka dodatkowych szczegółów, aby nasz zespół serwisowy mógł wszystko przygotować z wyprzedzeniem.",
      selectServiceCategoryPrompt: "Wybierz kategorię usługi, aby zobaczyć wymagane pytania dla tej usługi.",
      noServiceQuestionsForType: "Brak dodatkowych pytań dla tego typu usługi. Możesz kontynuować z wnioskiem.",
      fileUploadGuidance: "JPEG/PNG do 5 MB na plik.",
      optionalServiceQuestion: "Pytanie opcjonalne — odpowiedz, jeśli pomaga to naszemu zespołowi.",
      requestCreated: "Wniosek Utworzony",
      underReview: "W Trakcie Przeglądu",
      inProgress: "W Trakcie",
      photo: "Zdjęcie",
      hiThere: "Cześć,",
      serviceRequestDeclinedMessage: "Przejrzeliśmy Twój wniosek o usługę, ale nie mógł zostać zatwierdzony w tym momencie.",
      whatWeNeed: "Czego potrzebujemy:",
      declineReasonGeneric: "Może to wynikać z brakujących szczegółów, uprawnień do usługi lub innych warunków zatwierdzenia.",
      declineInstruction: "Proszę przejrzeć swoje informacje i przesłać nowy wniosek po wprowadzeniu tych aktualizacji.",
      answered: "Odpowiedziano",
      pendingAnswer: "Oczekiwanie na odpowiedź",
      requiredField: "Ta odpowiedź jest wymagana",
      questionsAnswered: "pytania odpowiedziano",
      readyToSubmitChanges: "Gotowy do przesłania aktualizacji",
      questionsUpToDate: "Wszystkie odpowiedzi są aktualne",
      updateAnyAnswerToResubmit: "Zaktualizuj dowolną odpowiedź powyżej, jeśli musisz wysłać nowe informacje.",
      answerTypeText: "Tekst",
      answerTypeYesNo: "Tak / Nie",
      answerTypeDropdown: "Lista rozwijana",
      answerTypeMultiSelect: "Wielokrotny wybór",
      answerTypeFileUpload: "Przesyłanie zdjęcia",
      pendingApproval: "Oczekuje na Zatwierdzenie",
      awaitingMoreInformation: "Oczekuje na Więcej Informacji",
      closed: "Zamknięte",
      noServiceRequestsFound: "Nie znaleziono wniosków o usługę",
      fleetAllocation: "Przydział Floty",
      fleetAllocations: "Przydziały Floty",
      userAgreement: "Umowa Użytkownika",
      organisationCode: "Kod Organizacji",
      serviceReference: "Referencja Usługi",
      completionDate: "Data Ukończenia",
      addTask: "Dodaj Zadanie",
      noTaskFound: "Nie znaleziono zadań. Możesz dodać zadania ręcznie.",
      taskName: "Nazwa Zadania",
      features: "Funkcje",
      interiorFeatures: "Funkcje Wnętrza",
      exteriorFeatures: "Funkcje Zewnętrzne",
      safetyAndTechnicalFeatures: "Funkcje Bezpieczeństwa i Techniczne",
      otherFeatures: "Inne Funkcje",
      privateHiresNo: "Prywatne wynajęcie nr",
      pcoPrivateHiresHireDLNo: "PCO/prywatny wynajęcie dl no",
      gender: "Płeć",
      secondaryEmailAddress: "Sekundarna Adres E-mail",
      secondaryPhoneNumber: "Sekundarny Numer Telefonu",
      driverAge: "Wiek kierowcy",
      licenceDuration: "Czas trwania licencji",
      penaltyPoints: "Punkty karne",
      insuranceClaimsHistory: "Historia roszczeń ubezpieczeniowych",
      pcoExpiryDate: "Data ważności PCO",
      state: "Stan",
      selectBookingType: "Wybierz typ rezerwacji",
      selectBookingTypeDialog: "Wybierz jeden z poniższych typów rezerwacji, aby kontynuować",
      regularBooking: "Rezerwacja standardowa",
      contactlessBooking: "Rezerwacja bezkontaktowa",
      reviewBookingDetails: "Przejrzyj szczegóły rezerwacji",
    },
    misc: {
      edit: "Edytuj",
      logOut: "Wyloguj się",
      licence: "Licencja",
      cancel: "Anuluj",
      save: "Zapisz",
      status: {
        PENDING: "Oczekujące",
        APPROVED: "Zatwierdzone",
        DECLINED: "Odrzucone",
        IN_REVIEW: "W trakcie przeglądu",
      },
      delete: "Usuń",
      create: "Utwórz",
      signIn: "Zaloguj się",
      select: "Wybierz",
      back: "Wstecz",
      error: "Błąd",
      yes: "Tak",
      no: "Nie",
      payConfirm: "Zapłać i potwierdź",
      clickToAdd: "Kliknij, aby dodać",
      close: "Zamknij",
      download: "Pobierz",
      selectCaps: "WYBIERZ",
      forgotPassword: "Zapomniałeś hasła",
      pleaseNote: "Proszę zauważyć",
      front: "Przód",
      columnKey: {
        "#": "#",
        Particulars: "Szczegóły",
        Quantity: "Ilość",
        "Unit Price": "Cena jednostkowa",
        Duration: "Czas trwania",
        "Discounted Price": "Cena z rabatem",
        "VAT/TAX": "VAT/PODATEK",
        Amount: "Kwota",
      },
      columnLabelToKeyMap: {
        ITEM: "POZYCJA",
        DESCRIPTION: "OPIS",
        QUANTITY: "ILOŚĆ",
        "UNIT PRICE": "CENA JEDNOSTKOWA",
        DURATION: "CZAS TRWANIA",
        "DISCOUNTED PRICE": "CENA Z RABATEM",
        "VAT/TAX": "VAT/PODATEK",
        PRICE: "CENA",
      },
      paymentColumnsKey: {
        Date: "Data",
        Amount: "Kwota",
        "Mode Of Payments": "Sposób płatności",
        Status: "Status",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Numer faktury",
        "Vehicle Registration Numbers": "Numer(y) rejestracyjny(e) pojazdu"
      },
      buttonKey: {
        Rentals: "Wynajem",
        Subscriptions: "Subskrypcje",
        "Test Drive": "Jazda próbna",
        "Contract Hire": "Wynajem na umowę",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Zarezerwuj pojazd na godziny i dni",
        "Subscribe vehicle for weekly/monthly":
          "Subskrybuj pojazd tygodniowo/miesięcznie",
        "Test Drive our Premium Vehicles": "Wypróbuj nasze pojazdy premium",
        "Contract Hire vehicle for weekly/monthly":
          "Wynajem pojazdu tygodniowy/miesięczny na umowę",
      },
      buttonTextKey: {
        "Subscribe Now": "Subskrybuj teraz",
        "Book Now": "Zarezerwuj teraz",
        "Contract Now": "Zawrzyj umowę teraz",
      },
      featuresKey: {
        "Flexible Leasing Options": "Elastyczne opcje leasingu",
        "Choose the duration of your subscription as you go":
          "Wybierz czas trwania subskrypcji w dowolnym momencie",
        "Change car anytime*": "Zmień samochód w każdej chwili*",
        "Home delivery option": "Opcja dostawy do domu",
        "100% digital": "100% cyfrowe",
        "MOT and taxes": "Przegląd techniczny i podatki",
        "Without down payment": "Bez wpłaty własnej",
        "Vehicle Servicing": "Serwisowanie pojazdu",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Kwota",
        "Adjusted To Invoice": "Dostosowano na fakturze",
        "Adjusted At": "Dostosowano dnia",
      },
      categoriesKey: {
        Knowledge: "Wiedza",
        Behavior: "Zachowanie",
        Punctuality: "Punktualność",
      },
    },
    snackBar: {
      customerInfoSaved: "Zapisane informacje o kliencie",
      documentDeleted: "Dokument pomyślnie usunięty",
      documentDeleteFailed: "Nie udało się usunąć dokumentu",
      documentDeleteError: "Dokument usuwania błędów",
      documentMarkedForDeletion:
        "Dokument jest oznaczony do usunięcia. Zmiany zostaną zastosowane po zapisaniu. ",
      profileImageUploaded: "Profilowy obraz przesłany pomyślnie",
      uploadImageFormatError: "Prześlij tylko .JPEG/.jpg/.png Format obrazu!",
      selectDocumentType: "Wybierz typ dokumentu",
      selectExpiryDate: "Wybierz datę wygaśnięcia dokumentu",
      fileSizeExceeded50mb: "Rozmiar pliku przekroczył limit 50 MB",
      fileSizeExceeded5mb: "Rozmiar pliku przekroczył limit 5 MB",
      uploadSuccess: "Dokument przesłany pomyślnie",
      invalidUploadFormat: "Prześlij tylko pliki PDF, PNG, JPG lub JPEG",
      selectExpiryDateUpload: "Przed przesłaniem wybierz datę ważności",
      ImageUploaded: "Obraz przesłany pomyślnie",
      invalidFileType: "Nieprawidłowy typ pliku. Dozwolone typy: jpeg lub png",
      costCenterInfoMissing: "Brak informacji o centrum kosztów!",
      selectedDriverAlreadyAdded: "Wybrany kierowca został już dodany.",
      driverSavedSuccessfully: "Kierowca został pomyślnie zapisany.",
      additionalDriverCannotBeMore:
        "Dodatkowi kierowcy nie mogą być więcej niż ilość dodatków",
      verificationStatusInReview: "Status weryfikacji jest w trakcie przeglądu",
      verificationStatusPending: "Status weryfikacji oczekuje",
      quoteCreated: "Oferta utworzona",
      bookingCreated: "Rezerwacja utworzona",
      pickUpLocationEmpty: "Miejsce odbioru jest puste",
      slotSelectionRequiredForNonNegotiable:
        "Wymagany jest wybór przedziału czasowego.",
      protectionPlanMandatoryForPCOBooking:
        "Plan ochrony jest wymagany przy rezerwacji PCO",
      paymentAlreadyDone: "Płatność została już dokonana",
      fileBeingGenerated: "Plik jest generowany, spróbuj ponownie za chwilę",
      provideDeliveryAddress: "Podaj adres dostawy!",
      noValidCreditReadingFound:
        "Brak ważnego odczytu kredytowego dla tej firmy.",
      noValidCreditScoreFound:
        "Nie znaleziono ważnego wyniku kredytowego. Limit zapytań mógł zostać przekroczony.",
      atleastOneLicenceImage: "Prześlij co najmniej jeden obraz prawa jazdy",
      licenceImageUploaded: "Obraz prawa jazdy został pomyślnie przesłany",
      maximumTwoImageLicence:
        "Można przesłać maksymalnie dwa obrazy prawa jazdy!",
      imageUploadInProgress: "Trwa przesyłanie obrazu, proszę czekać!",
      errorFetchingSignedUrl: "Błąd podczas pobierania podpisanego URL",
      paymentFailed: "Płatność nie powiodła się, spróbuj ponownie",
      paymentFailedReasonCardDetails:
        "Twoja płatność nie powiodła się! Sprawdź dane karty lub spróbuj ponownie później.",
      maximumTwoImage: "Można przesłać maksymalnie dwa obrazy dla",

      cancelledSuccessfully: "Anulowano pomyślnie",
      selectReasonForCancel: "Proszę podać powód anulowania",
      streetZipcodeRequired: "Ulica / Kod pocztowy jest wymagany",
      feedbackSaved: "Dziękujemy! Twoja opinia została zapisana",
      driverAlreadyAdded: "Kierowca został już dodany!",
      driverRemoved: "Kierowca został pomyślnie usunięty",
      businessCustomerDriverDeleted: "Kierowca klienta biznesowego usunięty.",
      errorInSavingData: "Błąd podczas zapisywania danych",
      damageInformationSaved: "Informacje o uszkodzeniach zapisane pomyślnie.",
      errorSavingData: "Błąd zapisu danych",
      problemTelematicsData: "Problem z ładowaniem danych telematycznych",
      verificationRequestSent: "Żądanie weryfikacji zostało pomyślnie wysłane.",
      vehicleStateUpdated: "Stan pojazdu został zaktualizowany",
      driverAdded: "Kierowca został dodany.",
      businessCustomerCreated: "Klient biznesowy został utworzony.",
      uploadOnlyImageFiles: "Proszę przesłać tylko pliki obrazów (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Rozmiar obrazu nie powinien przekraczać 5MB",
      uploadFailed: "Przesyłanie nie powiodło się",
      imagesUploadedSuccessfully: "obraz(y) przesłano pomyślnie!",
      failedToUploadImages: "Nie udało się przesłać obrazów. Spróbuj ponownie.",
      pleaseSelectVehicle: "Proszę wybrać pojazd",
      pleaseFillInAllIssueDetails: "Proszę wypełnić wszystkie szczegóły problemu",
      serviceRequestCreatedSuccessfully: "Zgłoszenie serwisowe utworzone pomyślnie! Numer referencyjny:",
      errorCreatingServiceRequest: "Błąd podczas tworzenia zgłoszenia serwisowego",
      pleaseEnterNote: "Proszę wprowadzić notatkę",
      noteAddedSuccessfully: "Notatka dodana pomyślnie",
      errorAddingNote: "Błąd podczas dodawania notatki",
      pleaseAnswerAllRemainingQuestions: "Proszę odpowiedzieć na wszystkie {{count}} pozostałe pytani{{plural}}",
      answersSubmittedSuccessfully: "Odpowiedzi przesłane pomyślnie! Twoje zgłoszenie jest teraz sprawdzane.",
      errorSubmittingAnswers: "Błąd podczas przesyłania odpowiedzi",
      serviceRequestNotFound: "Nie znaleziono zgłoszenia serwisowego",
      errorLoadingServiceRequests: "Błąd podczas ładowania wniosków o usługę",
      oneVehicleForContactless: "Dla rezerwacji bezkontaktowej można wybrać tylko jeden pojazd",
      oneVehicleForNonContactless: "Dla rezerwacji bezkontaktowej można wybrać wyłącznie pojazd bezkontaktowy lub Smartcar",
      contactlessVehicleCannotBeSelected: "Pojazd bezkontaktowy nie może zostać wybrany do standardowej rezerwacji",
      bookingDetailsCreated: "Szczegóły rezerwacji zostały utworzone"
    },
    validation: {
      otpLengthMismatch: "Długość OTP musi wynosić 6 znaków",
      invalidOtp: "Nieprawidłowy kod jednorazowy",
      required: "{{field}} jest wymagane",
      billingEmailInvalid: "Wprowadź ważny e -mail z rozliczeniami.",
      billingEmailRequired: "Wymagany jest e -mail rozliczeniowy.",
      addressRequired: "Adres jest wymagany",
      phoneNumberRequired: "Numer telefonu jest wymagany.",
      businessNameRequired: "Nazwa firmy jest wymagana.",
      registrationNumberRequired: "Wymagany jest numer rejestracyjny",
      vatRequired: "Wymagany jest numer VAT/NIP",
      accountNumberRequired: "Wymagany jest numer konta",
      registeredAddressRequired: "Wymagany jest zarejestrowany adres",
      registeredAddressCountryRequired: "Kraj jest wymagany",
      registeredAddressStateRequired: "Wymagany jest stan",
      registeredAddressCityRequired: "Miasto jest wymagane",
      registeredAddressStreetRequired: "Wymagana jest ulica",
      tradingAddressRequired: "Wymagany jest adres handlowy",
      tradingAddressCountryRequired: "Kraj jest wymagany",
      tradingAddressStateRequired: "Wymagany jest stan",
      tradingAddressCityRequired: "Miasto jest wymagane",
      tradingAddressStreetRequired: "Wymagana jest ulica",
      contactEmailRequired: "Wymagany jest kontakt e -mail.",
      firstNameRequired: "Wymagane jest imię.",
      middleNameRequired: "Drugie imię jest wymagane.",
      lastNameRequired: "Wymagane jest nazwisko.",
      locationRequired: "Wymagana jest lokalizacja",
      streetZipcodeRequired: "Wymagany jest street/zipcode",
      emailIsRequired: "Adres e-mail jest wymagany",
      termsConditionsAccepted: "Warunki muszą zostać zaakceptowane",
      drivingLicenceNumberRequired: "Wymagany jest numer prawa jazdy",
      nationalInsuranceNumberRequired:
        "Wymagany jest numer ubezpieczenia narodowego",
      enterValidPhoneNumber: "Wprowadź prawidłowy numer telefonu.",
      enterValidEmailAddress: "Proszę podać poprawny adres e-mail",
      authorityRequired: "Wymagany jest organ",
      licenceNumberRequired: "Numer prawa jazdy jest wymagany",
      licenceExpiryDateRequired: "Wymagana jest data ważności prawa jazdy",
      expiryDateRequired: "Wymagana data ważności",
      numberIsRequired: "Wymagany numer",

      passwordLengthValidaion: "Hasło musi mieć co najmniej 8 znaków",
      passwordContainUppercase:
        "Hasło musi zawierać co najmniej jedną wielką literę",
      passwordContainLowercase:
        "Hasło musi zawierać co najmniej jedną małą literę",
      passwordContainOneNumber: "Hasło musi zawierać co najmniej jedną cyfrę",
      passwordContainSpecialCharacter:
        "Hasło musi zawierać co najmniej jeden znak specjalny",
      passwordMustMatch: "Hasła muszą się zgadzać",
      atleastOneUppercase: "Co najmniej jedna wielka litera",
      atleastOneLowercase: "Co najmniej jedna mała litera",
      atleastOneNumericalChar: "Co najmniej jedna cyfra",
      atleastOneSpecialChar: "Co najmniej jeden znak specjalny",
      pleaseEnterAValidEmail: "Proszę wprowadzić prawidłowy adres e-mail",
      driverNotFound: "Kierowca nie został znaleziony",
      batteryStatusNumber: "Stan baterii musi być liczbą",
      batteryStatusCantNegative: "Stan baterii nie może być ujemny",
      batteryStatusCantMoreHundred: "Stan baterii nie może przekraczać 100%",
      batteryStatusRequired: "Stan baterii jest wymagany",
      odometerReadingMustNumber: "Odczyt licznika musi być liczbą",
      odometerReadingRequired: "Odczyt licznika jest wymagany",
      odometerMustEqualOrHigherLast:
        "Odczyt licznika musi być równy lub wyższy niż ostatni zapis",
      titleIsRequired: "Tytuł jest wymagany.",
      damageKindIsRequired: "Rodzaj uszkodzenia jest wymagany.",
      descriptionIsRequired: "Opis jest wymagany.",
      damageImageIsRequired: "Obraz uszkodzenia jest wymagany.",
      professionIsRequired: "Wymagany jest zawód",
      passportNineCharacters: "Numer paszportu musi mieć 9 znaków",
      passportIsRequired: "Wymagany jest paszport",
      organisationCodeRequired: "Wymagany jest kod organizacji",
      userNotFound: "Użytkownik nie znaleziony",
      invalidPassword: "Nieprawidłowe hasło",
      passwordLengthError: "Hasło musi mieć co najmniej 8 znaków",
      customerPCONumberRequired: "Numer PCO / prywatnej licencji wynajmu jest wymagany",
      genderRequired: "Płeć jest wymagana",
      nationalityRequired: "Narodowość jest wymagana",
    },
  },
};